import React from "react";
import "./Footer.scss";
import packageJson from "../../../package.json";

const version = process.env.REACT_APP_VERSION;
function Footer() {
  return (
    <>
      <div className="footer">
        <p className="copyright-label text-center">
          ©2024 Synoverge Technologies Pvt. Ltd. All Rights Reserved. Version: {packageJson.version}
        </p>
      </div>
    </>
  );
}

export default Footer;
